import { ComponentDataDestService } from '../component-data-dest.service';
import { ComponentDataSourceService } from '../../component-data-source/component-data-source.service';
import { catchError, map } from 'rxjs';
import { environment } from '../../../environment/environment';

export function log_contact_form(componentDataDestService: ComponentDataDestService, componentDataSourceService: ComponentDataSourceService, data: any) {

    // Validate required fields
    const requiredFields = ['name', 'email', 'message'];
    for (const field of requiredFields) {
        if (!data[field] || !data[field].trim()) {
            throw new Error(`Missing required field: ${field}`);
        }
    }

    // Prepare the contact form data
    const contactFormData = {
        name: data.name.trim(),
        email: data.email.trim(),
        message: data.message.trim(),
        subject: data.subject ? data.subject.trim() : 'General Inquiry'
    };

    // Send to API endpoint that logs the form submission
    const request$ = componentDataDestService.http.post(`${environment.apiUrl}/contact-form`, contactFormData).pipe(
        catchError(error => {
            console.error("Error in log_contact_form:", error);
            throw error;
        }),
        map(response => {
            return response;
        })
    );

    // Return the request observable without subscribing here
    // The component will handle the subscription
    return request$;
} 